/* eslint-disable react/prop-types */
import React from 'react';
import './Roller.css';

const Roller = ({ size = 20 }) => {
  return <span className="loader" style={{ width: `${size}px`, height: `${size}px` }}></span>;
};

export default Roller;
